import React from "react";
import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { navItems } from "../data/navigation";
export function Footer() {
  const groups = navItems.filter(i => i.children);
  const simple = navItems.filter(i => !i.children);
  return <footer className="bg-ink text-sand" data-id="element-79" data-mp="32m1c310wf4po">
      <div className="mx-auto grid max-w-site gap-12 px-5 py-16 md:grid-cols-12 md:px-8 md:py-20" data-id="element-80" data-mp="36qhgexuv642s">
        <div className="md:col-span-4" data-id="element-81" data-mp="3ug3e1gvl8b8o">
          <Logo tone="light" data-id="element-82" data-mp="3ucxndx7b91au" />
          <p className="mt-6 max-w-xs text-[15px] leading-relaxed text-sand/70" data-id="element-83" data-mp="38h3r5ed5aiu">
            Aménageur de vans et fourgons de loisirs, en plein cœur du Pays Basque.
          </p>
        </div>

        {groups.map(group => <nav key={group.label} aria-label={group.label} className="md:col-span-3" data-id="element-84" data-mp="3qcdtr3ly4ftg">
            <h2 className="text-sm font-semibold text-white" data-id="element-85" data-mp="29yxdpewb9omv">{group.label}</h2>
            <ul className="mt-5 space-y-3" data-id="element-86" data-mp="2ey09e8qeiii6">
              {group.children?.map(c => <li key={c.href} data-id="element-87" data-mp="3l9k6xg5ljtev">
                  <Link to={c.href} className="text-[15px] text-sand/70 transition-colors duration-150 hover:text-white" data-id="element-88" data-mp="3lalh7iesgbvj">
                    {c.label}
                  </Link>
                </li>)}
            </ul>
          </nav>)}

        <nav aria-label="MANY Loisirs" className="md:col-span-2" data-id="element-89" data-mp="3v5dgqrrxl8sy">
          <h2 className="text-sm font-semibold text-white" data-id="element-90" data-mp="3q7264ettau9o">MANY Loisirs</h2>
          <ul className="mt-5 space-y-3" data-id="element-91" data-mp="81yv6dh5zo1c">
            {simple.map(s => <li key={s.href} data-id="element-92" data-mp="34gwdfwv2p72">
                <Link to={s.href} className="text-[15px] text-sand/70 transition-colors duration-150 hover:text-white" data-id="element-93" data-mp="335ujlmz7ril">
                  {s.label}
                </Link>
              </li>)}
          </ul>
        </nav>
      </div>
      <div className="border-t border-white/10" data-id="element-94" data-mp="cw3617tjwg7p">
        <div className="mx-auto flex max-w-site flex-col gap-3 px-5 py-6 text-sm text-sand/60 md:flex-row md:justify-between md:px-8" data-id="element-95" data-mp="qujkjkxnnb0e">
          <p data-id="element-96" data-mp="mptqm1mk46i4">© 2026 MANY Loisirs. Tous droits réservés.</p>
          <div className="flex gap-6" data-id="element-97" data-mp="tw5w602sbejk">
            <Link to="/mentions-legales" className="hover:text-white" data-id="element-98" data-mp="tt09ssljiqrj">Mentions légales</Link>
            <Link to="/confidentialite" className="hover:text-white" data-id="element-99" data-mp="yuhb2p7xsf8n">Confidentialité</Link>
          </div>
        </div>
      </div>
    </footer>;
}